import clsx from 'clsx';
import { buttonProps } from '../../types';
import './index.scss';

export default function Button({
  variant = 'button--primary',
  children,
  className,
  disabled,
  ...restProps
}: buttonProps) {
  className = clsx(
    'button',
    variant,
    className,
    disabled ? 'button--disabled' : ''
  );

  return (
    <button
      {...restProps}
      className={className}
      disabled={disabled}>
      {children}
    </button>
  );
}
